<template>
  <div v-if="loading">
    <slot name="loader">
      <div class="loader" />
    </slot>
  </div>
  <div v-else>
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'LoadingWrapper',

    props: {
      loading: {
        type: Boolean,
        default: false
      }
    }
  };
</script>
